import { useMemo } from 'react';
import { Config } from '@leverege/plugin';
import useImage from 'use-image';
import { useSelector } from 'react-redux';
import { UI } from '@leverege/ui-redux';
const DEFAULT_LAYER_GETTER = () => ({
  layers: []
});
const DEFAULT_LAYER_SETTINGS_PATH = 'rsrc/overlays';
export default function useOverlay(props) {
  const {
    item,
    src,
    path,
    exclude
  } = props;
  const [image, status] = useImage(src, 'anonymous');
  const layerSettingsPath = Config.get('OverlayImageRenderers', 'layerSettingsPath', DEFAULT_LAYER_SETTINGS_PATH);
  const settings = useSelector(state => UI.get(state, layerSettingsPath));
  return useMemo(() => {
    const getLayersFromRsrc = Config.get('OverlayImageRenderers', `${path}/layerGetter`, Config.get('OverlayImageRenderers', 'layerGetter', DEFAULT_LAYER_GETTER));
    let {
      layers
    } = getLayersFromRsrc({
      item,
      image,
      settings
    });
    layers = getFilteredLayers(layers, exclude);
    return {
      layers,
      loading: status === 'loading'
    };
  }, [item, image, status, path, settings, exclude]);
}
function getFilteredLayers(layers, exclude = []) {
  if (!exclude) {
    return layers;
  }
  return layers.reduce((layerCollection, layer) => {
    const matcher = excludeLayer(layer.layerType);
    if (!exclude.some(matcher)) {
      const data = layer.data.reduce((dataCollection, datum) => {
        const dataMatcher = excludeLayer(datum.layerType);
        if (!exclude.some(dataMatcher)) {
          dataCollection.push(datum);
        }
        return dataCollection;
      }, []);
      if (data.length !== 0) {
        layerCollection.push({
          ...layer,
          data
        });
      }
    }
    return layerCollection;
  }, []);
}
const SANITIZE_REGEX = /[#-.]|[[-^]|[?|{}]/g;
function excludeLayer(type) {
  return exclude => {
    if (!type) {
      return false;
    }
    let matchString = exclude,
      endsWith = false,
      startsWith = false;
    if (exclude.startsWith('*')) {
      matchString = matchString.slice(1);
      startsWith = true;
    }
    if (exclude.endsWith('*')) {
      matchString = matchString.slice(0, -1);
      endsWith = true;
    }
    if (!startsWith && !endsWith) {
      return matchString === type;
    }
    matchString = matchString.replace(SANITIZE_REGEX, '\\$&');
    return (!startsWith || new RegExp(`^.*${matchString}`).test(type)) && (!endsWith || new RegExp(`${matchString}.*$`).test(type));
  };
}